export enum IncomingCashTypeEnum {
  High = 0,
  Average = 1,
  Low = 2,
}

export enum IncomingCashListNoSplit {
  AsAList = 0,
  NoSplit = 1,
}
